import React, { useState } from "react";
import SimplePage from "./SimplePage";

const faqs = [
  {
    q: "How do I get started with Tally?",
    a: "Sign up at app.gettally.store, enter your shop details, and you're ready to record your first sale within minutes. No card needed for your first 60 days.",
  },
  {
    q: "Does my customer need to download anything?",
    a: "No. Your customer opens go.gettally.store on any phone browser, enters their slip code, and their visit is saved instantly. No download, no app store.",
  },
  {
    q: "How do I record a sale?",
    a: "Open your Tally dashboard, go to Sales, enter the amount, and you'll get a unique slip code instantly. Hand that code to your customer however works for you — written down, printed, or shown on screen.",
  },
  {
    q: "How does Tally know when a customer stops coming?",
    a: "Tally tracks each customer's normal visit pattern. When someone who usually visits every couple of weeks goes quiet for longer than usual, you're alerted so you can reach out before they're gone for good.",
  },
  {
    q: "Is messaging my customers really free?",
    a: "Yes. You can message your entire customer list, or a specific group like at-risk customers, for free — any time, no limits.",
  },
  {
    q: "Can I add staff accounts?",
    a: "Yes. Every slip is tied to the staff member who issued it, so you always know who recorded which sale.",
  },
  {
    q: "What happens after my 60-day free trial?",
    a: "You can continue on our Pro plan at ₦5,000/month, or reach out if you need an Enterprise plan for multiple locations. Your data is never lost regardless of your plan.",
  },
  {
    q: "How do I cancel?",
    a: "Reach out to hello@gettally.store any time. There's no lock-in contract, and your customer data remains yours even if you cancel.",
  },
];

const Help: React.FC = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <SimplePage title="Help Centre">
      <p>
        Find quick answers below, or reach out directly at{" "}
        <a href="mailto:hello@gettally.store">hello@gettally.store</a> and
        we'll get back to you.
      </p>

      <h2>Frequently asked questions</h2>
      {faqs.map((item, i) => (
        <div key={i} className="help-faq-item">
          <div className="help-faq-item__q" onClick={() => setOpen(open === i ? null : i)}>
            <span>{item.q}</span>
            <span>{open === i ? "−" : "+"}</span>
          </div>
          {open === i && <div className="help-faq-item__a">{item.a}</div>}
        </div>
      ))}

      <h2>Still need help?</h2>
      <p>
        Email us at <a href="mailto:hello@gettally.store">hello@gettally.store</a>{" "}
        or message us on WhatsApp — we typically respond within a few hours.
      </p>
    </SimplePage>
  );
};

export default Help;